import React from 'react';
import { useTranslation } from 'react-i18next';
import './PolicyScreen.css';

const PolicyScreen = ({ title, content, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="policy-screen">
      <div className="policy-container">
        <div className="policy-header">
          <h1>
            <i className="fas fa-file-alt"></i> {title}
          </h1>
        </div>
        <div className="policy-content">
          <p>{content}</p>
        </div>
        <div className="policy-footer">
          <button 
            className="btn btn-secondary" 
            onClick={onClose}
          >
            <i className="fas fa-arrow-left"></i> {t('common.back')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PolicyScreen;